import { Component, OnInit } from '@angular/core';
import { SkillService } from '../../services/skill.service';
import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';

@Component({
  selector: 'app-skill-list',
  templateUrl: './skill-list.component.html'
})
export class SkillListComponent implements OnInit {
  loadingPage: boolean = true;
  session: any;
  skills: any[] = [];
  constructor(
    private sessionService: SessionService,
    private cacheService: CacheService,
    private skillService: SkillService,
  ) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  initView() {
    this.loadingPage = true;
    this.skillService.getAll().subscribe(
      (result: any) => {
        this.skills = result;
        // remove skills that shouldn't be allowed in this account
        for (let idx=this.skills.length-1; idx>=0; idx--) {
          if (!this.session.f.otterbot && this.skills[idx].type.indexOf('otterbot') >= 0) {
            this.skills.splice(idx, 1);
          }
          else if (!this.session.f.bot && this.skills[idx].type.indexOf('bot') >= 0) {
            this.skills.splice(idx, 1);
          }
        }
        this.loadingPage = false;
      },
      error => {
        // todo:
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/automate/skill-list/skill-list.component.ts